import LeftNav from "../LeftNav";
import '../styles/People.css'
import { useLocation, useNavigate } from "react-router-dom";
import { styled, css } from 'styled-components'
import { useEffect, useRef, useState } from "react";
import { authorizedHttpGet, authorizedHttpPost } from "../../api/httpCalls";
import urls from "../../api/urls.json";
import Loader from "../Loader";
import { convertTimestampToFormattedDate } from "../../utils";
import ImageWrapper from "../ImageWrapper";
import StatsModal from "./Stats";
import previous_inctive from '../../assests/arrow_back_grey.png';
import verified_icon from '../../assests/verified.svg';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import { BottomButtonAction, FeedbackButtonConfirmation } from '../../styles/ButtonStyles'
import PageModal from "../modals/PageModal";
import GenderModal from "../modals/GenderModal";
import DeviceType from "../DeviceType";
import EmptyView from "../EmptyView";
import CropImage from '../CropImage';
import ReviewPage from "../ReviewPage";
import background_svgrepo from '../../assests/background_svgrepo.com.svg'
import quality_svgrepo from '../../assests/quality_svgrepo.com.svg'
import smilecircle_svgrepo from '../../assests/smilecircle_svgrepo.com.svg'
import lampflashlight_svgrepo from '../../assests/lampflashlight_svgrepo.com.svg'
import standing_svgrepo from '../../assests/standing_svgrepo.com.svg'
import no_image_available from '../../assests/no_image.jpeg'
import { uploadCroppedImageToS3 } from "../../api/imageUpload";
import ShareRefControl from "../ShareRefControl";

const flags = {
    "Regular": "fb_no_flags",
    "Women": "women",
    "International": "international",
    "Flags": "fb_flags_with_friends",
}

const itemsPerPage = 1;

const FeedbackWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: auto;
    justify-items: center;
    align-items: center;
`;


const FeedbackWarning = styled.div`
    width: 300px;
    height: 100px;
    background-color: #ffc2c2;
    margin-left: 600px;
    margin-top: -200px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const PopupWrapper = styled.div`
  position: absolute;
  bottom: 100px; /* Moves the popup above the button */
  left: 500px;
  background: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 5px;
  z-index: 100; /* Ensures it's above other elements */
`;

const ReasonRadioDiv = styled.div`
    display: flex;
    text-align: left;
    padding: 5px;
    background-color: ${(props) => (props.isSelected ? "#d1e7fd" : "transparent")};
    border-radius: 5px;
    transition: background-color 0.3s ease-in-out;
`;

const ClosePopupButton = styled.button`
    background: "transparent";
    border: "none";
    fontSize: "18px";
    cursor: "pointer"; 
    color: "#aaa" ;
`;

const PeoplePremiuimRecheck = (props) => {
    const screenWidth = window.innerWidth;
    const isIpad = screenWidth === 1180;
    const currentTab = props.currentTab;
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [page, setPage] = useState(1);
    const [tabName, setTabName] = useState('Regular');
    const totalPages = useRef(1);
    const totalProfiles = useRef(0);
    const totalPendingProfiles = useRef(0);
    const [isLoading, setIsLoading] = useState(false);
    const [profiles, setProfiles] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentProfile = profiles.slice(startIndex, endIndex);
    const totalProfilesInPage = Math.ceil(profiles.length / itemsPerPage);
    const [firstName, setFirstName] = useState('');
    const [gender, setGender] = useState('');
    const dragOverItem = useRef();
    const dragImageUrl = useRef();
    const [decoy, setDecoy] = useState(false);
    const list = useRef([]);
    const columnNames = useRef([]);
    const [displayStatsModal, setDisplayStatsModal] = useState(false);
    const [displayReviewPage, setDisplayReviewPage] = useState(false);
    const [likedProfiles, setLikedProfiles] = useState([]);
    const [passedProfiles, setPassedProfiles] = useState([]);
    const [inappProfiles, setInappProfiles] = useState([]);
    const [banProfiles, setBanProfiles] = useState([]);
    const [togglePageModal, setTogglePageModal] = useState(false);
    const [displayGenderModal, setDisplayGenderModal] = useState(false);
    const [showCropImage, setShowCropImage] = useState(false);
    const [cropPhoto, setCropPhoto] = useState('')
    const [startDate, setStartDate] = useState(new Date());
    const feedbackIcons = [
        { icon: background_svgrepo, description: "background" },
        { icon: quality_svgrepo, description: "quality" },
        { icon: smilecircle_svgrepo, description: "expression" },
        { icon: lampflashlight_svgrepo, description: "lighting" },
        { icon: standing_svgrepo, description: "posture" }
    ];
    const feedback = {
        bad_background: false,
        bad_quality: false,
        bad_expression: false,
        bad_lighting: false,
        bad_posture: false,
    }
    const [photoFeedback, setPhotoFeedback] = useState([]);
    const [showFeedbackWarning, setShowFeedbackWarning] = useState(false);
    const [showReasonPopup, setShowReasonPopup] = useState(false);
    const [selectedReason, setSelectedReason] = useState(null);

    const getRecheckCurator = (profile) => {
        if (profile.last_curator === 'hive' && profile.auto_feed_checked_by) {
            return profile.auto_feed_checked_by;
        }
        return profile.last_curator;
    }

    const reasonOptions = [
        { value: "Stock/Celeb", label: "Stock/Celeb/Mismatch" },
        { value: "No Face/less Face", label: "No Face/less Face" },
        { value: "Blurry/low Res", label: "Blurry/low Res" },
        { value: "Heavy Edits", label: "Heavy Edits" },
        { value: "no reason", label: "no reason" }
    ];

    const handleInappClick = () => {
        setShowReasonPopup(!showReasonPopup);
    };

    const handleReasonSelect = (reason = null) => {
        setSelectedReason(reason); // Highlight selected reason
        setTimeout(() => {
            handleActionButton(currentProfile, "inapp", reason);
            setShowReasonPopup(false);
            setSelectedReason(null); // Reset after closing
        }, 250);
    };

    const resetState = () => {
        setLikedProfiles([]);
        setPassedProfiles([]);
        setInappProfiles([]);
        setBanProfiles([]);
        setCurrentPage(1);
        setPage(1);
        setTabName('Regular');
    }

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Enter') {
                if (displayReviewPage) {
                    if (passedProfiles.length > 0 || likedProfiles.length > 0 || inappProfiles.length > 0) {
                        saveResults()
                    }
                }
            }
            if (!displayReviewPage) {
                if (event.key === 'ArrowLeft' && currentPage > 1) {
                    if (currentPage > 1) { setCurrentPage(currentPage - 1) }
                } else if (event.key === 'ArrowRight') {
                    if (currentPage === totalProfilesInPage) { setDisplayReviewPage(true) }
                    if (currentPage < totalProfilesInPage) { setCurrentPage(currentPage + 1) }

                } else if (event.key === 'Shift') {
                    if (currentProfile[0]) { handleActionButton(currentProfile, 'like') }
                } else if (event.key === '/') {
                    if (currentProfile[0]) { handleActionButton(currentProfile, 'pass') }
                } else if (event.key === '.') {
                    if (currentProfile[0]) { setShowReasonPopup(true) }
                }
            } else {
                if (event.key === 'ArrowLeft') {
                    setDisplayReviewPage(false);
                }
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });

    const handleLeftNavAppChange = (name) => {
        setAppName(name)
        resetState();
    };

    const handleTabChange = (name) => {
        setTabName(name)
        setLikedProfiles([]);
        setPassedProfiles([]);
        setInappProfiles([]);
        setBanProfiles([]);
        setCurrentPage(1);
        setPage(1);
    }

    const clearAllSelections = () => {
        setLikedProfiles([]);
        setPassedProfiles([]);
        setInappProfiles([]);
        setBanProfiles([]);
    }

    const fetchPeopleData = async () => {
        setProfiles([]);
        clearAllSelections()
        let url, params;
        if (currentTab === 'Premium') {
            url = urls.GET_PREMIUM
            params = {
                page: page,
            }
        } else if (currentTab === 'People') {
            url = urls.GET_PEOPLE_TAB
            params = {
                bucket: flags[tabName],
                page: page,
            }
        } else {
            url = urls.GET_RECHECK
            params = {
                page: page,
            }
        }
        setIsLoading(true);

        let response = await authorizedHttpGet(url, params);
        if (response?.data) {
            totalProfiles.current = response.data.total_profiles;
            totalPendingProfiles.current = response.data.total_pending_profiles;
            totalPages.current = response.data.total_pages;
            setProfiles(Array.isArray(response.data.profiles) ? response.data.profiles : []);
        }
        setIsLoading(false);
    }

    const getStatsData = async (date) => {
        setIsLoading(true);
        let response = await authorizedHttpGet(urls.GET_STATS, {
            "date": date, 
            "app_name": appName,
        })
        if (response.status) {
            list.current = response.data.scoreboard_data;
            columnNames.current = response.data.column_names;
            setDisplayStatsModal(true);
            setIsLoading(false);
        }
        setIsLoading(false);
    }

    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value)
        currentProfile[0].first_name = e.target.value
    }

    const dragStart = (e, position, url) => {
        dragImageUrl.current = url;
        dragOverItem.current = position;
    };

    const dragEnter = (e, position) => {
        dragOverItem.current = position;
    };

    const dropImage = () => {
        setDecoy(!decoy);
        currentProfile[0].photos[dragOverItem.current] = { "photo": dragImageUrl.current };
        dragImageUrl.current = null;
        dragOverItem.current = null;
    }

    const addImage = (path, index) => {

        if (index === undefined) {
            return
        } else {
            setDecoy(!decoy);
            currentProfile[0].photos[index] = { photo: path };
            setDecoy(!decoy);
        }
    }

    const deleteImage = (index) => {
        setDecoy(!decoy);
        currentProfile[0].photos.splice(index, 1);
    }

    const setSelectedImage = (index) => {
        setDecoy(!decoy);
        currentProfile[0].photos.map((obj, i) => {
            if (i === index) {
                obj.selected = true;
            } else {
                obj.selected = false;
            }
        });
    }

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        } else if (direction === 'next' && currentPage < totalProfilesInPage) {
            setCurrentPage(currentPage + 1);
        }
        if (currentPage + 1 === endIndex) {
            setDisplayReviewPage(true);
        }
        if (profiles.length === currentPage) {
            setDisplayReviewPage(true);
        }
    };

    const removeProfileByRef = (profileArray, refToRemove) => {
        return profileArray.filter((obj) => obj.ref !== refToRemove);
    };

    const isRefAlreadyPresent = (profileArray, refToFind) => {
        return profileArray.some((obj) => obj.ref === refToFind);
    }

    const handleActionButton = (profile, button, reason = null) => {
        let changeCurrentPage = false;
        if (button === 'like') {
            if (isRefAlreadyPresent(likedProfiles, profile[0].ref)) {
                let removedProfile = removeProfileByRef(likedProfiles, profile[0].ref);
                setLikedProfiles(removedProfile);
                changeCurrentPage = false;
            } else {
                const refToFind = profile[0].ref;
                const updatedPassedProfiles = removeProfileByRef(passedProfiles, refToFind);
                const updatedInappProfiles = removeProfileByRef(inappProfiles, refToFind);
                const updatedBanProfiles = removeProfileByRef(banProfiles, refToFind);
                setPassedProfiles(updatedPassedProfiles);
                setInappProfiles(updatedInappProfiles);
                setBanProfiles(updatedBanProfiles);
                setLikedProfiles(existingData => ([...existingData, ...profile]));
                changeCurrentPage = true;
            }

        } else if (button === 'pass') {
            // if (photoFeedback.length === 0 && appName === 'Aisle' && currentTab !== 'Recheck') {
            //     setShowFeedbackWarning(true)
            //     return
            // }
            if (isRefAlreadyPresent(passedProfiles, profile[0].ref)) {
                let removedProfile = removeProfileByRef(passedProfiles, profile[0].ref);
                setPassedProfiles(removedProfile);
                changeCurrentPage = false;
            } else {
                const refToFind = profile[0].ref;
                const updatedLikedProfiles = removeProfileByRef(likedProfiles, refToFind);
                const updatedInappProfiles = removeProfileByRef(inappProfiles, refToFind);
                const updatedBanProfiles = removeProfileByRef(banProfiles, refToFind);
                setLikedProfiles(updatedLikedProfiles);
                setInappProfiles(updatedInappProfiles);
                setBanProfiles(updatedBanProfiles);
                setPassedProfiles(existingData => ([...existingData, ...profile]));
                changeCurrentPage = true;
            }
        } else if (button === 'inapp') {
            if ((isRefAlreadyPresent(inappProfiles, profile[0].ref) && reason === null) || (reason === null)){
                let removedProfile = removeProfileByRef(inappProfiles, profile[0].ref);
                setInappProfiles(removedProfile);
                changeCurrentPage = false;
            } else {
                const refToFind = profile[0].ref;
                const updateRemovedProfile = removeProfileByRef(inappProfiles, refToFind);
                const updatedLikedProfiles = removeProfileByRef(likedProfiles, refToFind);
                const updatedPassedProfiles = removeProfileByRef(passedProfiles, refToFind);
                const updatedBanProfiles = removeProfileByRef(banProfiles, refToFind);
                setInappProfiles(updateRemovedProfile);
                setBanProfiles(updatedBanProfiles);
                setLikedProfiles(updatedLikedProfiles);
                setPassedProfiles(updatedPassedProfiles);
                profile[0].inapp_reason = reason;
                setInappProfiles(existingData => ([...existingData, ...profile]));
                changeCurrentPage = true;
            }
        } else if (button === 'ban') {
            if (isRefAlreadyPresent(banProfiles, profile[0].ref)) {
                let removedProfile = removeProfileByRef(banProfiles, profile[0].ref);
                setBanProfiles(removedProfile);
                changeCurrentPage = false;
            } else {
                const refToFind = profile[0].ref;
                const updatedLikedProfiles = removeProfileByRef(likedProfiles, refToFind);
                const updatedPassedProfiles = removeProfileByRef(passedProfiles, refToFind);
                const updatedInappProfiles = removeProfileByRef(inappProfiles, refToFind);
                setLikedProfiles(updatedLikedProfiles);
                setPassedProfiles(updatedPassedProfiles);
                setInappProfiles(updatedInappProfiles);
                setBanProfiles(existingData => ([...existingData, ...profile]));
                changeCurrentPage = true;
            }
        }
        if (profiles.length === currentPage) {
            setDisplayReviewPage(true);
        }

        if (changeCurrentPage) {
            setCurrentPage(currentPage + 1)
            setPhotoFeedback([])
        }
    }

    const saveResults = async () => {
        setIsLoading(true);
        let params, url;
        if (currentTab === 'Premium') {
            params = {
                "approve": likedProfiles,
                "disapprove": passedProfiles,
                "inappropriate": inappProfiles,
                "banned": banProfiles,
                "page": page,
            }
            url = urls.POST_PREMIUM
        } else if (currentTab === 'People') {
            params = {
                "approve": likedProfiles,
                "disapprove": passedProfiles,
                "inappropriate": inappProfiles,
                "banned": [],
                "page": page,
                "disapproved_refs": [],
                "bucket": flags[tabName],
            }
            url = urls.POST_PEOPLE_TAB
        } else {
            params = {
                "approve": likedProfiles,
                "disapprove": passedProfiles,
                "inappropriate": inappProfiles,
                "banned": [],
                "page": page,
                "disapproved_refs": [],
                "bucket": "retry_curation",
            }
            url = urls.POST_RECHECK
        }

        const updatedParams = {
            ...params,
            feedback: photoFeedback
        }

        let response = await authorizedHttpPost(url, updatedParams)
        if (response.status) {
            await fetchPeopleData()
            setDisplayReviewPage(false);
            setCurrentPage(1);
            setLikedProfiles([]);
            setPassedProfiles([]);
            setInappProfiles([]);
            setBanProfiles([]);
        }
        setIsLoading(false);
    }

    const cancelSave = () => {
        if (page < totalPages.current) {
            setLikedProfiles([]);
            setPassedProfiles([]);
            setInappProfiles([]);
            // setPage(Number(page) + 1);
            setDisplayReviewPage(false);
            setCurrentPage(1);
        }
    }

    const goToPage = (pageModalNumber) => {
        setTogglePageModal(false);
        if (pageModalNumber > totalPages.current) {
            alert("Page number is greater than total pages");
        } else {
            setPage(pageModalNumber);
        }
    }

    const updateGender = (gen) => {
        currentProfile[0].gender = gen
        setGender(gen)
        setDisplayGenderModal(false)
    }

    const saveCroppedImage = async (croppedImage) => {
        try {
            setIsLoading(true);
            const profileRef = currentProfile[0]?.ref;
            const s3Url = await uploadCroppedImageToS3(croppedImage, profileRef);
            const index = localStorage.getItem('photoIndex');
            setDecoy(!decoy);
            currentProfile[0].photos[index] = { photo: s3Url };
            setShowCropImage(false);
            setDecoy(!decoy);
        } catch (e) {
            console.error('Failed to save cropped image', e);
        } finally {
            setIsLoading(false);
        }
    }

    const showImageCrop = (photo) => {
        setCropPhoto(photo)
        setShowCropImage(true);
    }

    useEffect(() => {
        setCurrentPage(1);
        fetchPeopleData()
        if (displayReviewPage) {
            setDisplayReviewPage(false)
        }
    }, [page, tabName, currentTab, appName])

    useEffect(() => {
        if (currentProfile[0]) {
            setFirstName(currentProfile[0].first_name)
            setGender(currentProfile[0].gender)
        }
    }, [currentProfile])

    const handleStatsDateChange = async (date) => {
        setStartDate(date)
        getStatsData(date)
    }

    const handleSuspicious = () => {
        currentProfile[0].is_suspicious = !currentProfile[0].is_suspicious
        setDecoy(!decoy)
    }

    const handleFeedback = (feedbackIcon, currentPhoto, event) => {
        const feedbackItem = feedbackIcon[0];
        const feedbackIndex = feedbackIcon[1];
        const selectedFeedback = document.getElementsByClassName(`feedback${currentProfile[0].ref}${feedbackItem}${feedbackIndex}`)[0];
        const feedbackSelected = selectedFeedback.classList.contains('feedbackSelected')
        const exisitingFeedback = currentPhoto.feedback || feedback;

        // check if feedbackSelected class exists
        currentPhoto.feedback = { ...exisitingFeedback, [`bad_${feedbackItem}`]: feedbackSelected ? false : true };
        const updatedPhotoFeedback = feedbackSelected ? photoFeedback.filter(photoId => photoId !== currentPhoto.photo_id) : [...photoFeedback, currentPhoto.photo_id];
        selectedFeedback.classList.toggle('feedbackSelected');
        if (updatedPhotoFeedback.length > 0) {
            setShowFeedbackWarning(false)
        }

        setPhotoFeedback(updatedPhotoFeedback)

    };

    const handleFeedbackConfirmation = () => {
        photoFeedback.push(1)
        setShowFeedbackWarning(false)
        handleActionButton(currentProfile, 'pass')
    }

    if (displayStatsModal) {
        return (
            <div className="App">
                <LeftNav tabName={currentTab} handleLeftNavAppChange={handleLeftNavAppChange} />
                <StatsModal handleClose={
                    () => {
                        setDisplayStatsModal(false);
                    }
                } list={list.current} columnNames={columnNames.current} closeStats={() => { setDisplayStatsModal(false); setStartDate(new Date()) }} startDate={startDate} handleStatsDateChange={handleStatsDateChange} />
            </div>
        )
    }

    if (displayReviewPage) {
        return (
            <div>
                {isLoading && <Loader />}
                <div className="headerDivReview">
                    <div className={!isIpad ? "pageNumberDivPeople marginLeft250px" : "pageNumberDivPeople marginLeft50"} onClick={() => setTogglePageModal(true)}>
                        <span className="pageNumberSpanPeople selectedSpan">{page}</span>
                        <span className="pageNumberSpanPeople unSelectedSpan">{totalPages.current}</span>
                        <span className="pageNumberSpanPeople unSelectedSpan">{totalProfiles.current}</span>
                        <span className="pageNumberSpanPeople unSelectedSpan">{totalPendingProfiles.current}</span>
                    </div>
                    {
                        currentTab === 'People' &&
                        <div className="pageNumberDivPeople marginLeft20">
                            <span className={`pageNumberSpanPeople ${tabName === 'Regular' ? 'selectedSpan' : 'unSelectedSpan'}`} onClick={() => handleTabChange('Regular')}>Regular</span>
                            <span className={`pageNumberSpanPeople ${tabName === 'Women' ? 'selectedSpan' : 'unSelectedSpan'}`} onClick={() => handleTabChange('Women')}>Women</span>
                            <span className={`pageNumberSpanPeople ${tabName === 'International' ? 'selectedSpan' : 'unSelectedSpan'}`} onClick={() => handleTabChange('International')}>International</span>
                            <span className={`pageNumberSpanPeople ${tabName === 'Flags' ? 'selectedSpan' : 'unSelectedSpan'}`} onClick={() => handleTabChange('Flags')}>Flags</span>
                            <span className='unSelectedSpan' onClick={() => getStatsData(startDate)}>Stats</span>
                        </div>
                    }
                </div>

                <ReviewPage likes={likedProfiles} passed={passedProfiles} inappProfiles={inappProfiles} cancel={cancelSave} save={saveResults} tabType={'people'} ban={banProfiles} />
            </div>
        )
    } else {
        return (
            <div className="App">
                {isLoading && <Loader />}
                {togglePageModal && <PageModal goToPage={goToPage} page={page} closeModal={() => setTogglePageModal(false)} />}
                {displayGenderModal && <GenderModal closeModal={() => setDisplayGenderModal(false)} updateGender={updateGender} />}
                {showCropImage ? <CropImage photo={cropPhoto} closeModal={() => setShowCropImage(false)} saveCroppedImage={saveCroppedImage} /> : null}
                <LeftNav tabName={currentTab} handleLeftNavAppChange={handleLeftNavAppChange} />
                <div className="peopleMainDiv">
                    <div className="headerDiv">
                        <div className={!isIpad ? "pageNumberDivPeople marginLeft250px" : "pageNumberDivPeople marginLeft50"} onClick={() => setTogglePageModal(true)}>
                            <span className="pageNumberSpanPeople selectedSpan">{page}</span>
                            <span className="pageNumberSpanPeople unSelectedSpan">{totalPages.current}</span>
                            <span className="pageNumberSpanPeople unSelectedSpan">{totalProfiles.current}</span>
                            <span className="pageNumberSpanPeople unSelectedSpan">{totalPendingProfiles.current}</span>
                        </div>
                        {
                            currentTab === 'People' &&
                            <div className="pageNumberDivPeople marginLeft20">
                                <span className={`pageNumberSpanPeople ${tabName === 'Regular' ? 'selectedSpan' : 'unSelectedSpan'}`} onClick={() => handleTabChange('Regular')}>Regular</span>
                                <span className={`pageNumberSpanPeople ${tabName === 'Women' ? 'selectedSpan' : 'unSelectedSpan'}`} onClick={() => handleTabChange('Women')}>Women</span>
                                <span className={`pageNumberSpanPeople ${tabName === 'International' ? 'selectedSpan' : 'unSelectedSpan'}`} onClick={() => handleTabChange('International')}>International</span>
                                <span className={`pageNumberSpanPeople ${tabName === 'Flags' ? 'selectedSpan' : 'unSelectedSpan'}`} onClick={() => handleTabChange('Flags')}>Flags</span>
                                <span className='unSelectedSpan' onClick={() => getStatsData(startDate)}>Stats</span>
                            </div>
                        }
                        {currentProfile[0] ? <DeviceType className='deviceType' device_type={currentProfile[0].device_type} /> : null}
                        {currentProfile[0] && currentProfile[0].is_verified ? <DeviceType className='deviceType' device_type='verified' /> : null}
                    </div>
                    {
                        currentProfile[0] && !displayReviewPage &&
                        <div className={!isIpad ? "profileInfoBasicData" : "profileInfoBasicDataIpad"}>
                            <input className="profileNameInput" onChange={(e) => handleFirstNameChange(e)} value={firstName} />
                            {currentProfile[0].is_verified && <img src={verified_icon} className="verifiedTick" alt="verified tick" />}
                            <span className="profileInfoSpan" onClick={() => setDisplayGenderModal(true)}>/ {gender === 'Male' ? "M" : "F"}</span>
                            <span className="profileInfoSpan">/ {currentProfile[0].age}</span>
                            {
                                currentProfile[0].marital_status_v1 ? <span className="profileInfoSpan">/ {currentProfile[0].marital_status_v1.name}</span> : <span className="profileInfoSpan">/ - </span>
                            }
                            <span className="profileInfoSpan">/ {currentProfile[0].language_name}</span>
                            <span className="profileInfoSpan">/ {currentProfile[0].location_str}</span>
                            <span className="profileInfoSpan">/ {currentProfile[0].ref}</span>
                            <ShareRefControl
                                refValue={currentProfile[0].ref}
                                sourceTab={`People-${tabName}`}
                                compact={true}
                            />
                            <span className="profileInfoSpan">/ {convertTimestampToFormattedDate(currentProfile[0].application_date)}</span>
                            <span className="profileInfoSpan">/ {currentProfile[0].phone_code}</span>
                            {currentProfile[0].hive_image_update_review &&
                                <span className="profileInfoSpan">/ Hive image update - manual review</span>
                            }
                        </div>
                    }
                    {
                        currentProfile[0] && !displayReviewPage && currentTab === 'Recheck' &&
                        <div className="recheckSpanDiv">
                            <span className="recheckSpanDetails">
                                {
                                    currentProfile[0].profile_state +
                                    ' by: ' +
                                    getRecheckCurator(currentProfile[0])
                                }
                            </span>
                            {
                                currentProfile[0].feed_curator &&
                                <span className="recheckSpanDetails feedCuratorSpanDetails">
                                    Marked by: {currentProfile[0].feed_curator}
                                </span>
                            }
                        </div>
                    }
                    {
                        currentProfile[0] && !displayReviewPage &&
                        <div className={!isIpad ? "imageContainerPeople" : "imageContainerPeopleIpad"}>
                            {
                                [0, 1, 2, 3].map((photo, index) => (
                                    <div
                                        onDragStart={(e) => dragStart(e, index, currentProfile[0].photos[photo].photo)}
                                        onDragEnter={(e) => dragEnter(e, index)}
                                        onDragEnd={dropImage}
                                        className="dragAndDropPeople"
                                    >
                                        <ImageWrapper key={index} src={currentProfile[0].photos[photo]} addImage={addImage} selectedImage={() => setSelectedImage(index)} deleteImage={deleteImage} canDelete={currentProfile[0].photos.length > 1} toggleCrop={false} closeModal={() => { }} photoIndex={index} showImageCrop={showImageCrop} />
                                        {/* // {appName == 'Aisle' && currentTab != 'Recheck' && < FeedbackWrapper >
                                        //     {
                                        //         feedbackIcons.map((feedbackIcon, i) => {
                                        //             const currentPhoto = currentProfile[0].photos[photo];
                                        //             if (!currentPhoto) { return null; }
                                        //             const feedbackExists = (currentPhoto.feedback?.[`bad_${feedbackIcon.description}`])
                                        //             return (
                                        //                 <div className={`feedbackIconWrapper feedback${currentProfile[0].ref}${feedbackIcon.description}${index}${i} ${feedbackExists ? 'feedbackSelected' : ''}`} onClick={handleFeedback.bind(this, [`${feedbackIcon.description}`, `${index}${i}`], currentProfile[0].photos[photo])} key={i}><img src={feedbackIcon.icon} className='feedbackIcon' /></div>
                                        //             );
                                        //         })
                                        //     }
                                        // </FeedbackWrapper>} */}
                                    </div>
                                ))
                            }
                        </div>
                    }
                    {
                        currentProfile[0] && !displayReviewPage &&
                        <div className={!isIpad ? "selfieDiv" : "selfieDivIpad"}>
                            <img src={currentProfile[0].selfie_url || no_image_available} alt="selfie" className={!isIpad ? "selfieImage" : "selfieImageIpad"} />
                            {
                                showFeedbackWarning && <FeedbackWarning>
                                    Are you sure there's no feedback for this profile?
                                    <FeedbackButtonConfirmation onClick={handleFeedbackConfirmation}>Yes</FeedbackButtonConfirmation>
                                </FeedbackWarning>
                            }
                        </div>

                    }
                    {
                        currentProfile[0] && !displayReviewPage &&
                        <>
                            <div className={!isIpad ? "pprButtonDiv" : "pprButtonDivIpad"}>
                                {currentPage === 1 ? <img src={previous_inctive} alt="previous" className="previousImage cursorPointer" /> : <img src={previous_active} alt="previous" className="previousImage cursorPointer" onClick={() => handlePageChange('prev')} />}
                                <BottomButtonAction className={isRefAlreadyPresent(likedProfiles, currentProfile[0].ref) ? 'likeButtonActiveStyle' : 'likeButtonInActiveStyle'} onClick={() => handleActionButton(currentProfile, 'like')}>Approve</BottomButtonAction>
                                <BottomButtonAction className={isRefAlreadyPresent(passedProfiles, currentProfile[0].ref) ? 'passButtonActiveStyle' : 'passButtonInActiveStyle'} onClick={() => handleActionButton(currentProfile, 'pass')}>Disapprove</BottomButtonAction>
                                <BottomButtonAction className={isRefAlreadyPresent(inappProfiles, currentProfile[0].ref) ? 'inappButtonActiveStyle' : 'inappButtonInActiveStyle'} onClick={() => handleInappClick()}>Inapp</BottomButtonAction>
                                {(showReasonPopup || (isRefAlreadyPresent(inappProfiles, currentProfile[0].ref))) && (
                                    <PopupWrapper>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1px" }}>
                                            <h4 style={{ color: "red", marginLeft: 20 }}>Reason</h4>
                                            <ClosePopupButton onClick={() => handleReasonSelect()}>X</ClosePopupButton>
                                        </div>
                                        {reasonOptions.map((option) => (
                                            <ReasonRadioDiv key={option.value} isSelected={currentProfile[0].inapp_reason === option.value}>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="reason"
                                                        value={option.value}
                                                        onChange={() => handleReasonSelect(option.value)}
                                                    />
                                                    {option.label}
                                                </label>
                                            </ReasonRadioDiv>
                                        ))}
                                        
                                    </PopupWrapper>
                                )}
                                {currentTab === 'Premium' && <BottomButtonAction className={isRefAlreadyPresent(banProfiles, currentProfile[0].ref) ? 'inappButtonActiveStyle' : 'inappButtonInActiveStyle'} onClick={() => handleActionButton(currentProfile, 'ban')}>Ban</BottomButtonAction>}
                                {currentPage === totalPages.current ? <img src={next_inactive} alt="next" className="nextImage cursorPointer" /> : <img src={next_active} alt="next" className="nextImage cursorPointer" onClick={() => handlePageChange('next')} />}
                            </div>
                            {
                                currentTab === 'People' &&
                                <div className="checkboxDivIpad">
                                    <input className="checkBoxPeopleIpad" type="checkbox" checked={currentProfile[0].is_suspicious} onChange={handleSuspicious} />
                                </div>
                            }
                        </>
                    }
                    {
                        profiles.length === 0 && <EmptyView />
                    }
                </div>
            </div >
        )
    }


};

export default PeoplePremiuimRecheck;
